var path = 'app/scripts/modules/core/src/presentation/standalone.view.html';
var html = "<div class=\"standalone\">\n    <div class=\"col-md-6 col-md-offset-3\">\n      <div ng-include=\"detailsTemplateUrl\"></div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/presentation/standalone.view.html
// module id = 477
// module chunks = 0